import React from "react";
import { MDBCard } from "mdb-react-ui-kit";
import Skeleton from "@mui/material/Skeleton";
import play from "../../../images/business dashboard/play black.png";

const DashboardCard = (props) => {
  return (
    <div>
      {props.viewCome ? (
        <MDBCard
          className="dash-bus-card"
          style={{ backgroundColor: props.bg }}
        >
          <div className="dash-bus-card-tit">
            <p className="mb-2 mb-md-3">
              <span className="dash-bus-card-p1">{props.view}</span>
              {/* <br /> */}
              <span className="dash-bus-card-p2">بازدید</span>
            </p>
            <img className="dash-bus-card-img" src={props.img} alt="" />
          </div>
          <div className="dash-bus-card-p3">{props.title}</div>
          {/* <hr className="dash-bus-card-hr" />
          <div className="d-flex justify-content-between align-items-center">
            <span className="dash-bus-card-p4">جزییات بیشتر</span>
            <img className="dash-bus-card-img2" src={play} alt="" />
          </div> */}
        </MDBCard>
      ) : (
        <Skeleton
          className="dash-bus-card"
          height={130}
          variant="rectangular"
          animation="wave"
        />
      )}
    </div>
  );
};

export default DashboardCard;
